handleUserCreateResponse